import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { fetchTeams, deleteTeam } from "store/teamSlice";
import { useHistory } from "react-router-dom";

export default function TeamTable({ color }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { items: teams, loading, error } = useSelector(
    (state) => state.teams
  );

  useEffect(() => {
    dispatch(fetchTeams());
  }, [dispatch]);

  const handleCreate = () => {
    history.push("/admin/team/create");
  };

  const handleEdit = (id) => {
    history.push(`/admin/team/edit/${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this member?")) {
      dispatch(deleteTeam(id));
    }
  };

  return (
    <div
      className={
        "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
        (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
      }
    >
      {/* Header */}
      <div className="rounded-t mb-0 px-4 py-3 border-0 flex justify-between">
        <h3
          className={
            "font-semibold text-lg " +
            (color === "light"
              ? "text-blueGray-700"
              : "text-white")
          }
        >
          Team Members
        </h3>

        <button
          onClick={handleCreate}
          className="bg-blue-500 text-white px-4 py-2 rounded text-sm hover:bg-blue-600"
        >
          + Create Member
        </button>
      </div>

      {/* Table */}
      <div className="block w-full overflow-x-auto">
        <table className="items-center w-full bg-transparent border-collapse">
          <thead>
            <tr>
              {["Image", "Name", "Designation", "Actions"].map(
                (h, i) => (
                  <th
                    key={i}
                    className={`px-6 py-3 text-xs uppercase font-semibold text-left ${
                      color === "light"
                        ? "bg-blueGray-50 text-blueGray-500"
                        : "bg-lightBlue-800 text-lightBlue-300"
                    }`}
                  >
                    {h}
                  </th>
                )
              )}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" className="text-center p-4">
                  Loading...
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="4" className="text-center p-4 text-red-500">
                  {error}
                </td>
              </tr>
            ) : (
              teams.map((member) => (
                <tr key={member.id}>
                  <td className="px-6 py-4">
                    <img
                      src={member.profile_picture}
                      className="h-12 w-12 rounded-full object-cover"
                      alt=""
                    />
                  </td>
                  <td className="px-6 py-4 text-sm">
                    {member.full_name}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    {member.designation}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <button
                      onClick={() => handleEdit(member.id)}
                      className="bg-yellow-500 text-white px-3 py-1 rounded mr-2 text-xs"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(member.id)}
                      className="bg-red-500 text-white px-3 py-1 rounded text-xs"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

TeamTable.defaultProps = {
  color: "light",
};

TeamTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
